$(function () {
  $(".single-option-selector")
    .change(function () {
      $(this)
        .parents(".select-wrapper")
        .find(".selected-option")
        .text($("option:selected", this).text());
    })
    .change();

  $("#contact-us").submit(function (event) {
    event.preventDefault();
    var $form = $("#contact-us");
    jQuery.ajax({
      type: "POST",
      async: true,
      url: "/contact#contact-us",
      data: $form.serialize(),
      error: function (response) {
        console.log(response);
      },
      success: function (response) {
        $("#form-unsubmitted").toggle();
        $("#form-success").toggle();
        $("#contact-us").toggle();
      },
    });
  });
});
